import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { SectionTitle, Card, Field, Area, SaveButton } from "../ui";

export default function ConsultationSettings() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/admin/consultation-settings").then((res) => setS(res.data));
  }, []);

  const save = async () => {
    setSaving(true);
    const { _id, ...payload } = s;
    await api.put("/admin/consultation-settings", payload);
    toast.success("Consultation settings saved");
    setSaving(false);
  };

  if (!s) return <p className="text-charcoal-500">Loading…</p>;

  return (
    <div data-testid="admin-consultation">
      <SectionTitle title="Consultation settings" subtitle="Price, duration, policies, and what's included." />
      <div className="space-y-6">
        <Card>
          <div className="grid gap-4 sm:grid-cols-2">
            <Field label="Price (USD)" type="number" testid="consult-price" value={s.price} onChange={(v) => setS({ ...s, price: v })} />
            <Field label="Duration (minutes)" type="number" testid="consult-duration" value={s.duration_minutes} onChange={(v) => setS({ ...s, duration_minutes: v })} />
          </div>
        </Card>

        <Card>
          <Area
            label="What's included (one per line)"
            rows={5}
            testid="consult-included"
            value={(s.whats_included || []).join("\n")}
            onChange={(v) => setS({ ...s, whats_included: v.split("\n").map((l) => l.trim()).filter(Boolean) })}
          />
        </Card>

        <Card>
          <div className="space-y-4">
            <Area label="Reschedule policy" value={s.reschedule_policy} onChange={(v) => setS({ ...s, reschedule_policy: v })} />
            <Area label="Refund policy" value={s.refund_policy} onChange={(v) => setS({ ...s, refund_policy: v })} />
            <Area label="What to expect" value={s.what_to_expect} onChange={(v) => setS({ ...s, what_to_expect: v })} />
          </div>
        </Card>

        <Card>
          <h3 className="font-medium text-charcoal-800 mb-3">Platforms &amp; meeting links</h3>
          <Field
            label="Platforms (comma separated)"
            value={(s.platforms || []).join(", ")}
            onChange={(v) => setS({ ...s, platforms: v.split(",").map((x) => x.trim()).filter(Boolean) })}
          />
          <div className="mt-4 space-y-3">
            {(s.platforms || []).map((p) => (
              <div key={p} className="flex items-center gap-3">
                <span className="w-28 text-sm text-charcoal-700">{p}</span>
                <input
                  data-testid={`consult-link-${p}`}
                  value={(s.meeting_room_links || {})[p] || ""}
                  onChange={(e) => setS({ ...s, meeting_room_links: { ...s.meeting_room_links, [p]: e.target.value } })}
                  className="flex-1 bg-white border border-sand-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-sage/50"
                />
              </div>
            ))}
          </div>
        </Card>

        <SaveButton testid="consult-save" onClick={save} saving={saving} />
      </div>
    </div>
  );
}
